import config from "../config/application";
import { getService, postBodyService} from "./base.service";

const getAllClientSeller = 'client_seller/find_all';
const getFindAllClientSellerById = 'find_client_seller';
const getAllByClient = 'society';
const getAllDocumentTypeForHistory = 'find_all/document_type_history';
const getAllStatusDocumentTypes = 'find_all/status_document_type';
const getAllStatusPaymentTypes = 'find_all/status_payment_type';

class HistoryService {
    getFindAllClientSeller(json) {
        const url = `${config.data.income.history.url}${getAllClientSeller}`;
        return postBodyService(url, json);
    }
    getFindAllClientSellerById(json) {
        const url = `${config.data.income.history.url}${getFindAllClientSellerById}`;
        return postBodyService(url, json);
    }
    getFindAllPaymentHistoryByClient(client,json) {
        const url = `${config.data.income.history.url}${getAllByClient}/${client}`;
        return postBodyService(url, json);
    }
    getAllDocumentTypeForHistory() {
        const url = `${config.data.income.history.url}${getAllDocumentTypeForHistory}`;
        return getService(url);
    }
    getAllStatusDocumentTypes() {
        const url = `${config.data.income.history.url}${getAllStatusDocumentTypes}`;
        return getService(url);
    }
    getAllStatusPaymentTypes() {
        const url = `${config.data.income.history.url}${getAllStatusPaymentTypes}`;
        return getService(url);
    }
}
export default new HistoryService(); 